import React, { memo } from 'react';
import { useIntl } from 'react-intl';

import { User as UserType } from '../../types/User';
import { stopPropagation } from '../../utils/event';
import { getUserName } from '../../utils/getUserName';
import { Box } from '../Box/Box';
import { useShowMoreItems } from '../hooks/useShowMoreItems';
import { Layout } from '../Layout/Layout';
import { User } from '../User/User';

interface Props {
  /** List of users */
  users: UserType[];
  /** Limit the number of visible users */
  limit?: number;
  /** Number of hidden users to display */
  step?: number;
}

export const Users = memo(({ users, limit = users.length, step }: Props) => {
  const intl = useIntl();
  const [visibleUsers, showMore] = useShowMoreItems<UserType>({
    items: users,
    limit,
    serializeItem: (user) =>
      getUserName({
        user,
        intl,
      }),
    step,
  });

  return (
    <Layout preset="users">
      {visibleUsers.map((user) => (
        <Box border="avatar" borderRadius="round" key={user.id}>
          <User mode="avatar" user={user} />
        </Box>
      ))}
      <Box pl={3} onClick={stopPropagation}>
        {showMore}
      </Box>
    </Layout>
  );
});
